var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.901,
    height: 14.696,
    viewBox: "0 0 10.901 14.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash_1_",
    "data-name": "trash (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6128",
    "data-name": "Path 6128",
    d: "M20.272,63.745v1.762H10V63.745a.944.944,0,0,1,.944-.944h8.383A.944.944,0,0,1,20.272,63.745Zm0,0",
    transform: "translate(-9.685 -60.824)",
    fill: "#00efd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6129",
    "data-name": "Path 6129",
    d: "M47.073,148.814v8.333a1.283,1.283,0,0,1-1.259,1.353H39.861a1.283,1.283,0,0,1-1.259-1.353V148.8h8.472Zm0,0",
    transform: "translate(-37.387 -144.118)",
    fill: "#00acea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6130",
    "data-name": "Path 6130",
    d: "M222.917,192.091a.315.315,0,0,0,.315-.315v-6.262a.315.315,0,1,0-.629,0v6.262A.315.315,0,0,0,222.917,192.091Zm0,0",
    transform: "translate(-215.597 -179.371)",
    fill: "#083863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6131",
    "data-name": "Path 6131",
    d: "M104.116,192.091a.315.315,0,0,0,.315-.315v-6.262a.315.315,0,1,0-.629,0v6.262A.315.315,0,0,0,104.116,192.091Zm0,0",
    transform: "translate(-100.534 -179.371)",
    fill: "#083863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6132",
    "data-name": "Path 6132",
    d: "M9.642,1.662H8.106v-.4A1.26,1.26,0,0,0,6.847,0H4.053A1.26,1.26,0,0,0,2.794,1.259v.4H1.258A1.26,1.26,0,0,0,0,2.92V4.683A.315.315,0,0,0,.314,5H.9v8.031a1.711,1.711,0,0,0,.455,1.19,1.528,1.528,0,0,0,1.118.478H8.427a1.528,1.528,0,0,0,1.118-.478A1.711,1.711,0,0,0,10,13.028V5h.585a.315.315,0,0,0,.315-.315V2.92A1.26,1.26,0,0,0,9.642,1.662Zm-6.218-.4A.63.63,0,0,1,4.053.629H6.847a.63.63,0,0,1,.629.629v.4H3.423Zm5.948,11.77a.973.973,0,0,1-.944,1.038H2.473a.973.973,0,0,1-.944-1.038V5H9.371Zm.9-8.66H.629V2.92a.63.63,0,0,1,.629-.629H9.642a.63.63,0,0,1,.629.629Zm0,0",
    transform: "translate(0)",
    fill: "#083863"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash1);
export default __webpack_public_path__ + "static/media/trash (1).5a45d62a6defc79158f3da1732a8baf7.svg";
export { ForwardRef as ReactComponent };